import React, {useState} from 'react'
import {Button, Grid, Box, TextField, MenuItem} from '@material-ui/core'
import {Query} from 'react-apollo'
import {fieldEntityListStatus} from '../../graphql/barcode/queries/fieldEntityListStatusQuery'
import LoadingScreen from '../BarcodeLoadingScreen'
import Picky from 'react-picky'
import 'react-picky/dist/picky.css'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeFieldFilterSearch.styles'

export default function BarcodeFieldFilterSearch(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const [fieldFilterSearch, setFieldFilterSearch] = useState([])
  const [fieldFilterData, setFieldFilterData] = useState([])
  const [fieldSelected, setFieldSelected] = useState([])
  const [dataSelected, setDataSelected] = useState({})
  const userId = parseInt(window.localStorage.getItem('user_id'))

  const filterChange = selectChange => {
    if (selectChange === undefined || selectChange === null) {
      setFieldSelected([])
    } else {
      setFieldSelected(selectChange)
    }
  }

  function dataChange(event) {
    fieldSelected.map(data => {
      if (data.value === event.target.value.field_key) {
        setDataSelected({...dataSelected, [data.value]: event.target.value})
      }
      return dataSelected
    })
  }

  function applyFiltersClick(event) {
    props.filterValuesClick(event, dataSelected)
  }

  function resetButtonClick(event) {
    props.setTotalFilter(0)
    setDataSelected({})
    setFieldSelected([])
    props.resetButtonClick(event, 'filterReset')
  }

  return (
    <div>
      <Grid container className={classes.filterBackground} hidden={props.hideFilters}>
        <Grid container className={classes.titleStyle}>
          {t('barcode.wizard.field-filter.narrow-search')}
        </Grid>

        <Query
          query={fieldEntityListStatus}
          variables={{
            entityId: parseInt(props.entityId),
            token: props.token,
            userId: userId,
          }}
        >
          {({loading, error, data}) => {
            if (loading) {
              return (
                <div className={classes.loadingStyle}>
                  <LoadingScreen size={50} />
                </div>
              )
            }
            if (error) {
              return <div>{t('barcode.wizard.field-filter.error-loading')}</div>
            }

            setFieldFilterData(data['fieldEntityListStatus']['dataFields'])
            setFieldFilterSearch(data['fieldEntityListStatus']['fields'])

            return (
              <div className={classes.selectOption}>
                <Grid container item xs={12} spacing={2}>
                  <Grid container item xs={2}>
                    <Picky
                      value={fieldSelected || null}
                      options={fieldFilterSearch}
                      onChange={filterChange}
                      valueKey="value"
                      labelKey="label"
                      multiple={true}
                      numberDisplayed="0"
                      manySelectedPlaceholder="%s Filter(s)"
                      allSelectedPlaceholder="%s Filter(s)"
                      placeholder={t('barcode.wizard.field-filter.select-filter')}
                      className={classes.selectPicky}
                      buttonProps={{
                        className: classes.btnPicky,
                      }}
                    />
                  </Grid>

                  <Grid container item xs={8}>
                    {fieldFilterSearch.map((data, index) => (
                      <span key={data.value + index} className={classes.selectSpan}>
                        {!fieldSelected.includes(data) && delete dataSelected[data.value]}

                        <TextField
                          id="outlined-select-output"
                          select
                          label={data.label}
                          value={dataSelected[data.value] || ''}
                          className={classes.dataSelect}
                          onChange={dataChange}
                          SelectProps={{
                            className: classes.selectPropsBG,
                            MenuProps: {
                              getContentAnchorEl: null,
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                            },
                          }}
                          variant="filled"
                          hidden={!fieldSelected.includes(data)}
                        >
                          {fieldFilterData[data.value].map(record => (
                            <MenuItem key={record.value} value={record}>
                              {record.label}
                            </MenuItem>
                          ))}
                        </TextField>

                        {props.setTotalFilter(Object.keys(dataSelected).length)}
                      </span>
                    ))}
                  </Grid>

                  <Grid container item xs={2} justify="flex-end">
                    <Button
                      value="reset"
                      variant="contained"
                      className={classes.buttonLink}
                      color="primary"
                      size="large"
                      onClick={applyFiltersClick}
                    >
                      {t('barcode.wizard.field-filter.apply-filters')}
                    </Button>

                    <Button
                      value="reset"
                      variant="outlined"
                      className={classes.buttonLink}
                      color="primary"
                      onClick={resetButtonClick}
                    >
                      {t('barcode.wizard.field-filter.reset')}
                    </Button>
                  </Grid>
                </Grid>

                <Box marginTop={2} marginBottom={3} />
              </div>
            )
          }}
        </Query>
      </Grid>
    </div>
  )
}
